import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms'
import { ApiCatalogService } from '../../../api/api-catalog.service'

export function nicknameAsyncValidator(apiCatalogService: ApiCatalogService): AsyncValidatorFn {
  return async (control: AbstractControl): Promise<ValidationErrors | null> => {
    const value = control.value as string | null

    if (!value) {
      return null
    }

    if (/\s/.test(value) || value.length > 30) {
      return null
    }

    try {
      const isDuplicate = await apiCatalogService.NicknameSearch(value)
      return isDuplicate ? { nicknameTaken: true } : null
    } catch {
      return null
    }
  }
}
